module.exports = __webpack_public_path__ + "img/PXL_20230526_112207743.87088a0c.jpg";